export default {
    adminMenu: {
        dashboard: 'Tablero',
    },
}